// extracted by mini-css-extract-plugin
export default {"wrapper":"ActionsMenu_wrapper__0-Eaj","menuBtn":"ActionsMenu_menuBtn__535be","menu":"ActionsMenu_menu__J-U0j"};